import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { validateNoOverlappingGamTargetingPerInventoryPerDay } from '../validation/noOverlappingGamTargetingPerInventoryPerDay.ts'
import { getPercentageAllocationInventoryToTarget } from '../formatters/percentageAllocationHelpers/getPercentageAllocationInventoryToTarget'
import { getInventoryIds } from '../helpers'

import { lineItemsSelector } from '../../../../../../modules/selectors/lineItems'
import { rightSelector } from '../../../../../../modules/selectors/rights'
import { START_DATE, END_DATE } from '../../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import { ENVIRONMENT_TYPE } from '../fields'
import { AD_INVENTORY } from '../../../../../Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

export const useNoOverlappingGamTargetingValidation = (formValues, onValidationChange) => {
  const existingLineItems = useSelector(lineItemsSelector)
  const right = useSelector(rightSelector)

  const environmentType = formValues[ENVIRONMENT_TYPE]

  const validationResult = useMemo(() => {
    // Helper function to extract inventory IDs from current form values

    const placements = getPercentageAllocationInventoryToTarget(formValues, right)
    const proposedInventoryIds = getInventoryIds(placements)

    // If no placements are being targeted, no conflicts possible
    if (!proposedInventoryIds || proposedInventoryIds.length === 0) {
      const result = { isValid: true, errors: [] }
      onValidationChange?.(result)
      return result
    }

    const validation = validateNoOverlappingGamTargetingPerInventoryPerDay({
      existingLineItems,
      proposedStartDate: formValues[START_DATE],
      proposedEndDate: formValues[END_DATE],
      proposedInventoryIds,
      allInventory: right?.[AD_INVENTORY] || [],
      environmentType
    })

    onValidationChange?.(validation)
    return validation
  }, [formValues, existingLineItems, right, onValidationChange, environmentType])

  return validationResult
}

export default useNoOverlappingGamTargetingValidation
